/*
 * @format
 */

import { all } from 'redux-saga/effects';

import control from './controls';
import siSettings from './siSettings';
import prtCopySettings from './prtCopySettings';
import pendingZone from './pendingZone';
import geolocation from './geolocation';
import schedule from './schedule';
import pendingDsrCommands from './pendingDsrCommands';
import dsr from './dsr';
import haloNotificationMessages from './haloNotificationMessages';
import desiredStateSettling from './desiredStateSettling';

function* rootSaga() {
  yield all([
    control(),
    siSettings(),
    prtCopySettings(),
    pendingZone(),
    geolocation(),
    schedule(),
    pendingDsrCommands(),
    dsr(),
    haloNotificationMessages(),
    desiredStateSettling(),
  ]);
}

export default rootSaga;
